
import {Component, Ref, Vue, Watch} from 'vue-property-decorator';
import GridForm from "@/components/general/GridForm.vue";
import moment from "moment-mini";
import PdfViewerDialog from "@/components/general/PdfViewerDialog.vue";
import {globalEventBus} from "@/main";
import ConfirmationDialog from "@/components/general/ConfirmationDialog.vue";
import {AsyncServieCallType} from "@/assets/js/models/AsyncServiceCallType";


@Component({
    components: {ConfirmationDialog, GridForm, PdfViewerDialog},
})
export default class CashReport extends Vue {


    private async createCashReport() : Promise<void> {
        this.confirmDialog.showConfirmation("neuer Kassenbericht", "Das Erstellen eines Kassenberichts (Z-Bericht) überträgt die aktuellen Summen der Kasse in die App und setzt danach alle Umsätze in der Kasse zurück. Während des Vorgangs werden alle Geräte in dieser Filiale für die Bedienung gesperrt. Sie sollten diese Funktion daher nicht während des laufenden Tagesgeschäfts durchführen. ", async() => {

                try{
                    const taskId = await this.$ports.posManager.receiveFinancialReports();

                    if(taskId) {
                        const tasks = this.$store.getters["Base/tasks"];
                        tasks.push({
                            Nummer: taskId,
                            Type: AsyncServieCallType.receive_FinancialReports
                        });
                        this.$store.commit("Base/setTasks", tasks);
                        globalEventBus.$emit('transferChanged',{isTransmitting:true, title : "Kassenberichte werden erstellt"});
                    }

                }catch(e) {
                    globalEventBus.$emit("showError", e?.message);
                }
            } );
    }
    private name:any= undefined;
    private loading = false;
    @Ref()
    private pdfViewer!: PdfViewerDialog;
    @Ref()
    private confirmDialog!: ConfirmationDialog;
    private gridName = 'BROWSE_FILIALKASSENBERICHTE';

    private canCreate!: boolean;

    constructor() {
        super();
        this.canCreate = false;
    }

    private formObjectChanged() {
        // bewusst leer: @onFormObjectChanged wird gebunden, aber nicht ausgewertet
    }

    private filter = '';
    private singleSelectActions: any[] = [{
        icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><!--! Font Awesome Pro 6.3.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M64 464H96v48H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H229.5c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3V288H336V160H256c-17.7 0-32-14.3-32-32V48H64c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16zm96-112h24c30.9 0 56 25.1 56 56s-25.1 56-56 56h-8v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V448 368c0-8.8 7.2-16 16-16zm24 80c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8v48h8zm72-64c0-8.8 7.2-16 16-16h24c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H272c-8.8 0-16-7.2-16-16V368zm32 112h8c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16h-8v96zm96-128h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H400v32h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H400v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V432 368c0-8.8 7.2-16 16-16z"/></svg>',
        displayName: 'PDF Export',
        action: async (entry: any) => {
            console.log(entry);
            await this.rowItemClick({value: entry, id: entry.NUMMER, formName: "", tableName: ""});
        }
    }];
    // [{
    //     icon: '<i class="fas fa-print mr-2"></i>',
    //     displayName: 'Drucken',
    //     action: () => alert('print'),
    // }, {
    //     icon: '<i class="fas fa-trash mr-2"></i>',
    //     displayName: 'Stornieren',
    //     action: () => alert('cancel'),
    // }];
    private multiSelectActions: any[] = [];
    // [{
    //     icon: '<i class="fas fa-print mr-2"></i>',
    //     displayName: 'Alle Drucken',
    //     action: () => alert('print all'),
    // }, {
    //     icon: '<i class="fas fa-trash mr-2"></i>',
    //     displayName: 'Alle Stornieren',
    //     action: () => alert('cancel all'),
    // }];
    @Watch('branchId')
    private branchChanged() {
        this.$router.go(0);
    }

    private get branchId() {
        return this.$store.getters["Auth/branchId"];
    }

    private async rowItemClick(args: { value: any, id: any, formName: string, tableName: string }): Promise<void> {
        try {
            this.loading = true;
            if (args?.value?.DATUM) {
                const date = moment(args?.value?.DATUM, 'DD.MM.YYYY');
                const formattedDate = date.format("YYYY/MM/DD");
                const url = await this.$ports.posManager.getCashReport(formattedDate, args?.id);
                if (url.endsWith(".pdf")) {
                        await this.downloadFile(url);
                } else {
                    globalEventBus.$emit("showError", "Der Bericht konnte nicht geladen werden");
                }
            }
        } catch (e) {
            globalEventBus.$emit("showError", e.message);
        } finally {
            this.loading = false;
        }
    }

    private async downloadFile(file: string): Promise<void> {
        const a = document.createElement("a");
        a.style.display = "none";
        a.href = file;
        a.target = '_blank';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    }
}
